/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgInventoryTransfer = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M9.071 6.036H4.414l1.829 1.828-1.414 1.414L.586 5.036 4.829.793l1.414 1.414-1.829 1.829h4.657zm5.93 14h4.656l-1.828 1.828 1.414 1.414 4.242-4.242-4.242-4.243-1.414 1.414 1.828 1.829H15zM12.53 7.152a1 1 0 0 0-1.06 0l-4 2.5A1 1 0 0 0 7 10.5v4a1 1 0 0 0 .47.848l4 2.5a1 1 0 0 0 1.06 0l4-2.5A1 1 0 0 0 17 14.5v-4a1 1 0 0 0-.47-.848zM11 13.554v1.642l-2-1.25v-1.642zm4 .392-2 1.25v-1.642l2-1.25zm-.887-3.446L12 11.82 9.887 10.5 12 9.18z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgInventoryTransfer as InventoryTransfer };
